var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.411,
    height: 23.327,
    viewBox: "0 0 20.411 23.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M3.645,8.747V6.561a6.561,6.561,0,1,1,13.121,0V8.747h.729a2.919,2.919,0,0,1,2.916,2.916v8.747a2.919,2.919,0,0,1-2.916,2.916H2.916A2.917,2.917,0,0,1,0,20.411V11.663A2.917,2.917,0,0,1,2.916,8.747Zm2.916,0h7.29V6.561a3.645,3.645,0,1,0-7.29,0Z",
    fill: "#9f0404"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockRed);
export default __webpack_public_path__ + "static/media/lock-red.08b32a99ff439109e65138dd02e3ede0.svg";
export { ForwardRef as ReactComponent };